import { render } from "./expertJoin.vue?vue&type=template&id=1988e32a&scoped=true"
import script from "./expertJoin.vue?vue&type=script&lang=js"
export * from "./expertJoin.vue?vue&type=script&lang=js"

import "./expertJoin.vue?vue&type=style&index=0&id=1988e32a&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1988e32a"]])

export default __exports__